import { useEffect } from 'react';

import isBrowser from '../../../helpers/isBrowser';
import inertElement from './helpers/inertElement';

/**
 * Inerts the focusable elements of the body.
 * @param ignore - The IDs of body elements to ignore.
 * @return {void}
 */
const useInertSiblings = (selector: string): void => {
    useEffect(() => {
        if (isBrowser() === false) {
            return () => {}; // eslint-disable-line @typescript-eslint/no-empty-function
        }

        const selectedElement = document.querySelector(selector);

        if (!selectedElement || !selectedElement.parentElement) {
            return () => {}; // eslint-disable-line @typescript-eslint/no-empty-function
        }

        const siblings = Array.from(selectedElement.parentElement.children).filter((element) => {
            if (element.isSameNode(selectedElement)) {
                return false;
            }

            return true;
        });

        siblings.forEach((element) => {
            inertElement(element, true);
        });

        return () => {
            siblings.forEach((element) => {
                inertElement(element, false);
            });
        };
    }, [selector]);
};

export default useInertSiblings;
